module.exports = __webpack_public_path__ + "static/media/icon-file-light-blue.7eb277ce.svg";